<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router'
import { computed, onMounted, onUnmounted } from 'vue'
import AsideMenu from './components/core/AsideMenu.vue'
import authService from './services/authService'

const route = useRoute()

// Nascondi il menu sulla pagina di login
const showMenu = computed(() => route.name !== 'login')

// Avvia il timer di inattività se l'utente è già loggato
onMounted(() => {
  if (authService.isAuthenticated()) {
    authService.startInactivityTimer()
  }
})

// Pulisci quando il componente viene smontato
onUnmounted(() => {
  // Il cleanup viene gestito automaticamente dal logout
})
</script>

<template>
  <AsideMenu v-if="showMenu" />
  <div class="routing" :class="{ 'no-menu': !showMenu }">
    <RouterView />
  </div>
</template>

<style scoped>
.routing {
  margin-left: 135px;
}

.routing.no-menu {
  margin-left: 0;
}

@media (max-width: 567px) {
  .routing {
    margin-left: 0;
  }
}
</style>
